module.exports = __webpack_public_path__ + "media/img/uploads/solutions-slant-law-enforcement-bb0ea33240a788b40fb056db77deaaa1.jpg";